import { render, staticRenderFns } from "./CommentComposer.vue?vue&type=template&id=1155dc44&scoped=true&"
import script from "./CommentComposer.vue?vue&type=script&lang=js&"
export * from "./CommentComposer.vue?vue&type=script&lang=js&"
import style0 from "./CommentComposer.vue?vue&type=style&index=0&id=1155dc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155dc44",
  null
  
)

export default component.exports